import { useEffect, useMemo, useState } from "react"
import { useMainContext } from "../../../core/contexts/main"
import { formatDate, formatNumber } from "../../../core/utils/common"
import { Row, Column } from "../../../styles/TableStyle"
import FilterLayout from "../../layouts/FilterLayout"
import { FaLongArrowAltLeft } from "react-icons/fa"
import Text from "../../../core/utils/Text"
import { FlexCenter } from "../../../styles/CommonStyles"
import CoinImg from "../../common/CoinImg"
import { useTraceData } from "../../trace/useTraceData"

const AccountTraceTable = () => {
    const {
        main: { lang },
    } = useMainContext()

    const {
        filterQueries,
        traces,
        isFetching,
        onPageChange,
        searchId,
        setSearchId,
        onSearchById,
        initialState,
        setFilterQueries
    } = useTraceData()


    const totalPages = useMemo(() => traces?.meta?.total || 0, [traces])

    return (
        <FilterLayout
            headers={headers}
            data={traces}
            totalPages={totalPages}
            state={{
                filterQueries: filterQueries,
                setFilterQueries: setFilterQueries,
                initialState,
            }}
            loading={isFetching}
        >
            {traces?.data?.map((item) => {
                const diffBalance = item.balanceNew - item.balance
                const diffBlocked = item.balanceBlockedNew - item.balanceBlocked

                const balanceColor =
                    diffBalance > 0 ? "green-500" : diffBalance < 0 ? "red-500" : "gray-400"
                const blockedColor =
                    diffBlocked > 0 ? "green-500" : diffBlocked < 0 ? "red-500" : "gray-400"

                const typeColor =
                    item.type === "INCREASE"
                        ? "text-green-600"
                        : item.type === "DECREASE"
                            ? "text-red-500"
                            : "text-gray-400 dark:text-gray-500"

                return (
                    <Row key={item._id}>
                        <Column width="15%">
                            <FlexCenter className="gap-2">
                                <CoinImg id={item.currency} size={18} />
                                <span>{item.currency?.toUpperCase()}</span>
                            </FlexCenter>
                        </Column>

                        <Column width="10%" number>
                            {formatNumber(item.volume, { type: item.currency })}
                        </Column>

                        <Column width="20%" number>
                            <FlexCenter className="gap-2">
                                <span>{formatNumber(item.balance, { type: item.currency })}</span>
                                <FaLongArrowAltLeft
                                    className={`text-${balanceColor} ${lang === "en" ? "rotate-180" : ""
                                        }`}
                                />
                                <span>{formatNumber(item.balanceNew, { type: item.currency })}</span>
                            </FlexCenter>
                        </Column>

                        <Column width="20%" number>
                            <FlexCenter className="gap-2">
                                <span>{formatNumber(item.balanceBlocked, { type: item.currency })}</span>
                                <FaLongArrowAltLeft
                                    className={`text-${blockedColor} ${lang === "en" ? "rotate-180" : ""
                                        }`}
                                />
                                <span>
                                    {formatNumber(item.balanceBlockedNew, { type: item.currency })}
                                </span>
                            </FlexCenter>
                        </Column>

                        <Column width="10%">
                            <div className={`rounded-md py-1 px-2 text-center ${typeColor}`}>
                                <Text tid={item.type} />
                            </div>
                        </Column>

                        <Column width="10%">
                            <div className="rounded-md py-1 px-2 text-center bg-gray-200 dark:bg-gray-800 text-sm">
                                <Text tid={item.cause?.label} />
                            </div>
                        </Column>

                        <Column width="15%" number>
                            <div className="flex flex-col gap-1">
                                <span>{formatDate(item.createdAt, "time", lang)}</span>
                                <span>{formatDate(item.createdAt, "date", lang)}</span>
                            </div>
                        </Column>
                    </Row>
                )
            })}
        </FilterLayout>
    )
}

const headers = [
    { title: "currency", width: "15%" },
    { title: "volume", width: "10%" },
    { title: "balanceChange", width: "20%" },
    { title: "balanceBlockChange", width: "20%" },
    { title: "type", width: "10%" },
    { title: "cause", width: "10%" },
    { title: "date", width: "15%" },
]

export default AccountTraceTable
